import React from 'react';
import Ionicon from "react-ionicons";

export const PublishWarningError = props => {
    const { cancelWarningModal } = props;

    const mainMessage = {
        h2: "Have you completed your Profile?",
        p: "Please complete your summary and experience sections before publishing your profile.",
    };

    return (
        <div className="popup-default">
            <div className="popup-inner">
                <div className="popup-content">
                    <button className="close-popup" type="button" onClick={ () => cancelWarningModal() }><Ionicon icon="ion-close"/></button>
                    <h2 classname="h2">{ mainMessage.h2}</h2>
                    <p className="p-tag">{ mainMessage.p }</p>
                </div>
            </div>
        </div>
    )
};


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/PublishWarningError.js